mutation createConnection {
    konstantine {
        createConnection {
            id
            companyId
            apiKey
            status
        }
    }
}
